export const REQUEST_PASSWORD_MUTATION = `
  mutation requestPasswordReset($input: requestPasswordResetInput!) {
    public {
      requestPasswordReset(input: $input)
    }
  }
`;
